import PropTypes from 'prop-types';

import { IconButton } from "../../.."

import { colors } from "../../../../types/types";

import styles from '../MultiFileUpdate.module.css';

export const ArchivoForm = ({ element, removeElement }) => {

  return (
    <div className="row">
      <div className="col">
        <div className={styles.customMultiPreviewContainer}>
            <div key={element.id}><a className={styles.customMultiFilePreview} href={element.archivo}>{ element.archivoName }</a></div>
            <IconButton
              icon="X"
              iconColor={colors.DANGER}
              marginTop={false}
              onClick={() => removeElement(element.id)}
              type="button"
            />
        </div>
      </div>
    </div>
  )
}

ArchivoForm.propTypes = {
  element: PropTypes.any.isRequired,
  removeElement: PropTypes.func.isRequired,
}